<app-navbar [title]="title()" />

<div class="py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)] container mx-auto">
  <app-card>
    <form
      [formGroup]="contractForm"
      class="grid grid-cols-6 gap-2"
    >
      <div class="col-span-6">
        <p-button severity="contrast" variant="text" (click)="back()">
          <i class="fa-solid fa-arrow-left mr-2"></i>
          Voltar
        </p-button>
      </div>
      <app-card-header class="col-span-6" title="Informações Gerais" />

      @if (loading() && !contractId) {
        @for (item of [1,2,3,4,5,6]; track item) {
          <div class="col-span-6 md:col-span-3 xl:col-span-2 mt-4.5">
            <p-skeleton height="3rem" />
          </div>
        }
        <div class="col-span-6 mt-4.5">
          <p-skeleton height="3rem" />
        </div>
        <div class="col-span-6 mt-4.5">
          <p-skeleton height="9rem" />
        </div>
      } @else {
        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3 xl:col-span-2">
          <label for="title" class="text-sm">Título</label>
          <input
            pInputText
            id="title"
            formControlName="title"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('title')?.dirty && contractForm.get('title')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3 xl:col-span-2">
          <label for="start_date" class="text-sm">Data de Emissão</label>
          <p-datepicker
            formControlName="start_date"
            dateFormat="dd/mm/yy"
            dateFormat="dd/mm/yy"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="start_date"
            appendTo="body"
            fluid
            [invalid]="contractForm.get('start_date')?.dirty && contractForm.get('start_date')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3 xl:col-span-2">
          <label for="status" class="text-sm">Categoria</label>
          <p-select
            id="status"
            [options]="contractStatus | keyvalue"
            [showClear]="true"
            [filter]="true"
            formControlName="status"
            optionLabel="value"
            filterBy="value"
            optionValue="value"
            placeholder="Escolha um status"
            [invalid]="contractForm.get('status')?.dirty && contractForm.get('status')?.errors"
            appendTo="body"
            [disabled]="loading()"
          >
            <ng-template let-category #item>
                <div>{{ category.value | contractStatus }}</div>
            </ng-template>
            <ng-template let-category #selectedItem>
                <div>{{ category.value | contractStatus }}</div>
            </ng-template>
          </p-select>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3 xl:col-span-2">
          <label for="signature_date" class="text-sm">Data de Assinatura</label>
          <p-datepicker
            formControlName="signature_date"
            dateFormat="dd/mm/yy"
            dateFormat="dd/mm/yy"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="signature_date"
            appendTo="body"
            fluid
            [invalid]="contractForm.get('signature_date')?.dirty && contractForm.get('signature_date')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3 xl:col-span-2">
          <label for="execution_date" class="text-sm">Data de execução</label>
          <p-datepicker
            formControlName="execution_date"
            dateFormat="dd/mm/yy"
            dateFormat="dd/mm/yy"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="execution_date"
            appendTo="body"
            fluid
            [invalid]="contractForm.get('execution_date')?.dirty && contractForm.get('execution_date')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3 xl:col-span-2">
          <label for="termination_date" class="text-sm">Data de extinção</label>
          <p-datepicker
            formControlName="termination_date"
            dateFormat="dd/mm/yy"
            dateFormat="dd/mm/yy"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="termination_date"
            appendTo="body"
            fluid
            [invalid]="contractForm.get('termination_date')?.dirty && contractForm.get('termination_date')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6">
          <label for="people" class="text-sm">Partes</label>
          <p-multiselect
            id="people"
            [options]="contractForm.get('people')?.value"
            [showClear]="true"
            [filter]="true"
            formControlName="people"
            optionLabel="name"
            filterBy="name"
            [invalid]="contractForm.get('people')?.dirty && contractForm.get('people')?.errors"
            appendTo="body"
            [disabled]="loading()"
            multiple
          >
            <ng-template let-people #item>
                <div>{{ people.name }}</div>
            </ng-template>
            <ng-template let-people #selectedItem>
                <div class="p-1 border border-zinc-300 bg-zinc-50">{{ people.name }}</div>
            </ng-template>
          </p-multiselect>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6">
          <label for="description" class="text-sm">Descrição</label>
          <textarea
            pInputText
            id="description"
            formControlName="description"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('description')?.dirty && contractForm.get('description')?.errors"
            [disabled]="loading()"
            rows="5"
          ></textarea>
        </div>
      }

      <app-card-header class="col-span-6 mt-4" title="Rescisão" />

      @if (loading() && !contractId) {
        @for (item of [1,2]; track item) {
          <div class="col-span-6 md:col-span-3 mt-4.5">
            <p-skeleton height="3rem" />
          </div>
        }
      } @else {

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="termination_for_cause_days" class="text-sm">Rescisão por justa causa - Período de notificação (em dias)</label>
          <input
            pInputText
            id="termination_for_cause_days"
            formControlName="termination_for_cause_days"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('termination_for_cause_days')?.dirty && contractForm.get('termination_for_cause_days')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="termination_for_convenience_days" class="text-sm">Rescisão por conveniência - Período de notificação (em dias)</label>
          <input
            pInputText
            id="termination_for_convenience_days"
            formControlName="termination_for_convenience_days"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('termination_for_convenience_days')?.dirty && contractForm.get('termination_for_convenience_days')?.errors"
            [disabled]="loading()"
          />
        </div>
      }

      <app-card-header class="col-span-6 mt-4" title="Renovação" />

      @if (loading() && !contractId) {
        @for (item of [1,2]; track item) {
          <div class="col-span-6 md:col-span-3 mt-4.5">
            <p-skeleton height="3rem" />
          </div>
        }
      } @else {

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="renew_type" class="text-sm">Tipo de renovação</label>
          <p-select
            id="renew_type"
            [options]="contractRenewType | keyvalue"
            [showClear]="true"
            [filter]="true"
            formControlName="renew_type"
            optionLabel="value"
            filterBy="value"
            optionValue="value"
            [invalid]="contractForm.get('renew_type')?.dirty && contractForm.get('renew_type')?.errors"
            appendTo="body"
            [disabled]="loading()"
          >
            <ng-template let-type #item>
                <div>{{ type.value | contractRenewType }}</div>
            </ng-template>
            <ng-template let-type #selectedItem>
                <div>{{ type.value | contractRenewType }}</div>
            </ng-template>
          </p-select>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="renewal_notice_period_days" class="text-sm">Período de notificação da renovação (em dias)</label>
          <input
            pInputText
            id="renewal_notice_period_days"
            formControlName="renewal_notice_period_days"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('renewal_notice_period_days')?.dirty && contractForm.get('renewal_notice_period_days')?.errors"
            [disabled]="loading()"
          />
        </div>
      }

      <app-card-header class="col-span-6 mt-4" title="Pagamento" />

      @if (loading() && !contractId) {
        @for (item of [1,2,3,4,5,6,7,8,9,10]; track item) {
          <div class="col-span-6 md:col-span-3 mt-4.5">
            <p-skeleton height="3rem" />
          </div>
        }
      } @else {

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="type_value" class="text-sm">Modo de cobrança</label>
          <p-select
            id="type_value"
            [options]="contractTypeValue | keyvalue"
            [showClear]="true"
            [filter]="true"
            formControlName="type_value"
            optionLabel="value"
            filterBy="value"
            optionValue="value"
            [invalid]="contractForm.get('type_value')?.dirty && contractForm.get('type_value')?.errors"
            appendTo="body"
            [disabled]="loading()"
          >
            <ng-template let-type #item>
                <div>{{ type.value | contractTypeValue }}</div>
            </ng-template>
            <ng-template let-type #selectedItem>
                <div>{{ type.value | contractTypeValue }}</div>
            </ng-template>
          </p-select>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="value" class="text-sm">Valor do Contrato</label>
          <p-inputnumber
            id="value"
            formControlName="value"
            mode="currency"
            currency="BRL"
            locale="pt-BR"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('value')?.dirty && contractForm.get('value')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="payment_type" class="text-sm">Modo de cobrança</label>
          <p-select
            id="payment_type"
            [options]="contractPaymentType | keyvalue"
            [showClear]="true"
            [filter]="true"
            formControlName="payment_type"
            optionLabel="value"
            filterBy="value"
            optionValue="value"
            [invalid]="contractForm.get('payment_type')?.dirty && contractForm.get('payment_type')?.errors"
            appendTo="body"
            [disabled]="loading()"
          >
            <ng-template let-type #item>
                <div>{{ type.value | contractPaymentType }}</div>
            </ng-template>
            <ng-template let-type #selectedItem>
                <div>{{ type.value | contractPaymentType }}</div>
            </ng-template>
          </p-select>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="due_date" class="text-sm">Vencimento</label>
          <p-datepicker
            formControlName="due_date"
            dateFormat="dd/mm/yy"
            dateFormat="dd/mm/yy"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="due_date"
            appendTo="body"
            fluid
            [invalid]="contractForm.get('due_date')?.dirty && contractForm.get('due_date')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="payment_first_installment" class="text-sm">Valor da 1ª parcela</label>
          <p-inputnumber
            id="payment_first_installment"
            formControlName="payment_first_installment"
            mode="currency"
            currency="BRL"
            locale="pt-BR"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('payment_first_installment')?.dirty && contractForm.get('payment_first_installment')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="payment_installment" class="text-sm">Valor das demais parcelas</label>
          <p-inputnumber
            id="payment_installment"
            formControlName="payment_installment"
            mode="currency"
            currency="BRL"
            locale="pt-BR"
            fluid
            autocomplete="off"
            [invalid]="contractForm.get('payment_installment')?.dirty && contractForm.get('payment_installment')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="payment_frequency" class="text-sm">Frequência</label>
          <p-select
            id="payment_frequency"
            [options]="contractPaymentFrequency | keyvalue"
            [showClear]="true"
            [filter]="true"
            formControlName="payment_frequency"
            optionLabel="value"
            filterBy="value"
            optionValue="value"
            [invalid]="contractForm.get('payment_frequency')?.dirty && contractForm.get('payment_frequency')?.errors"
            appendTo="body"
            [disabled]="loading()"
          >
            <ng-template let-type #item>
                <div>{{ type.value | contractPaymentFrequency }}</div>
            </ng-template>
            <ng-template let-type #selectedItem>
                <div>{{ type.value | contractPaymentFrequency }}</div>
            </ng-template>
          </p-select>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <p-inputgroup>
            <input
              pInputText
              id="payment_day"
              formControlName="payment_day"
              fluid
              autocomplete="off"
              placeholder="Dia da recorrência"
              [invalid]="contractForm.get('payment_day')?.dirty && contractForm.get('payment_day')?.errors"
              [disabled]="loading()"
            />
              <p-inputgroup-addon>de cada mês</p-inputgroup-addon>
          </p-inputgroup>
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="payment_start_date" class="text-sm">Início da Recorrência</label>
          <p-datepicker
            formControlName="payment_start_date"
            dateFormat="dd/mm/yy"
            dateFormat="dd/mm/yy"
            [iconDisplay]="'input'"
            [showIcon]="true"
            inputId="payment_start_date"
            appendTo="body"
            fluid
            [invalid]="contractForm.get('payment_start_date')?.dirty && contractForm.get('payment_start_date')?.errors"
            [disabled]="loading()"
          />
        </div>

        <div class="flex flex-col justify-end gap-1 col-span-6 md:col-span-3">
          <label for="payment_end_date" class="text-sm">Fim da Recorrência</label>
          <p-inputgroup>
            <p-inputgroup-addon>Até o dia</p-inputgroup-addon>
            <p-datepicker
              formControlName="payment_end_date"
              dateFormat="dd/mm/yy"
              dateFormat="dd/mm/yy"
              [iconDisplay]="'input'"
              [showIcon]="true"
              inputId="payment_end_date"
              appendTo="body"
              [invalid]="contractForm.get('payment_end_date')?.dirty && contractForm.get('payment_end_date')?.errors"
              [disabled]="loading()"
              class="max-w-56"
            />
          </p-inputgroup>
        </div>

        <!-- <div class="col-span-6">
          <p-message severity="contrast" variant="simple" size="small">
            <b>Resumo:</b> Contrato recorrente mensal, cobrado uma vez por mês no dia 5, começando em 01/01/2025, terminando em 05/05/2025.
          </p-message>
        </div> -->
      }

      <app-card-header class="col-span-6 mt-4" title="Arquivos" />

      @if (loading() && !contractId) {
        @for (item of [1,2,3,4,5,6]; track item) {
          <div class="col-span-1 mt-4.5">
            <p-skeleton height="3rem" />
          </div>
        }
      } @else {
        <div class="col-span-6">
          <div class="text-sm">Arquivos adicionados ({{contractForm.get('docs')?.value.length}})</div>
          <div class="w-full flex flex-wrap items-center justify-start gap-2">
          @for (doc of contractForm.get('docs')?.value; track $index) {
            <div
              class="w-auto flex items-center justify-start gap-2 rounded-lg border border-zinc-600 p-2 cursor-pointer hover:bg-zinc-50"
              (click)="openFile(doc.doc)"
            >
              <i class="fa-solid fa-file"></i>
              <span class="text-zinc-900 text-sm">{{ doc.description }}</span>
            </div>
          }
          </div>
        </div>
      }

      <app-card-header class="col-span-6 mt-4" title="Notas" />

      @if (loading() && !contractId) {
        @for (item of [1,2,3]; track item) {
          <div class="col-span-6 mt-4.5">
            <p-skeleton height="3rem" />
          </div>
        }
      } @else {
        <div class="col-span-6">
          <div class="w-full divide-y divide-gray-300">
            @for (note of contractForm.get('notes')?.value; track $index) {
              <div class="w-full py-3">
                <div class="w-full flex items-start justify-between">
                  <div class="flex items-center justify-start gap-2">
                    <!-- <div>Logo</div> -->
                    <div class="flex flex-col items-start justify-start gap-1">
                      <div class="text-zinc-900">
                        {{ note.note }}
                      </div>
                    </div>
                  </div>
                  <div class="text-sm text-zinc-400 text-end">
                    @if (note.created_at === note.updated_at) {
                      <span>{{ note.created_at | date: 'medium' }}</span>
                    } @else {
                      <span>{{ note.created_at | date: 'dd/MM/y' }}</span>
                      <span> - Editado em {{ note.updated_at | date: 'medium' }}</span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

    </form>
  </app-card>
</div>
